import { NgModule } from '@angular/core';

import { ProviderModules } from './modules';

@NgModule({
  imports: ProviderModules
})
export class ApiAnalyticsModule { }
